import React from "react";
import AdditionalEmailgroups from "./atom/AdditionalEmailgroups";
import ConfigureEmailServer from "./atom/ConfigureEmailServer";
// import EmailNotification from "./atom/EmailNotification";

function Body({ domainBrand }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_EMAIL_SETTING_2052406034"]
                : "Email Settings"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            {/* EMAIL NOTIFICATIONS */}
            {/* <EmailNotification dictionary={dictionary} /> */}
            {/* ADDITIONAL EMAIL GROUPS */}
            <AdditionalEmailgroups dictionary={dictionary} />
            {/* CONFIGURE EMAIL SERVER */}
            <ConfigureEmailServer dictionary={dictionary} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
